import { VStack as OriginalVStack, Heading } from "@chakra-ui/react";

export function VStack(props) {
  return <OriginalVStack spacing="4" align="flex-start" {...props} />;
}

export function SectionHeading(props) {
  return <Heading as="h3" size="sm" color="purple.600" {...props} />;
}
